export default __webpack_public_path__ + "static/media/RobotoMono700.988ff87c.woff";